import { Box, Flex, Icon } from '@chakra-ui/react';
import { Appointment1 } from '@/assets/icons/sso';
import { KText } from '@/ui-library/components';
import { TradeMarkFooter } from '@/components/trade-mark-footer';
import { KulaTextLogo } from '@/assets/icons/colored';

const SSOFailurePage = () => {
  return (
    <Flex
      height="100vh"
      width="100vw"
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
    >
      <Box position="absolute" top="0" mt="36px">
        <Icon as={KulaTextLogo} w="90px" h="30px" />
      </Box>
      <Flex gap="24px" flexDirection="column">
        <Flex justifyContent="center" alignItems="center">
          <Icon as={Appointment1} w="50%" h="100%" />
        </Flex>
        <Flex gap="3px" flexDirection="column" alignItems="center">
          <KText size="xl-bold" color="secondary-900">
            Unable to log in with SSO
          </KText>
          <KText>Your SSO settings might be configured incorrectly</KText>
          <KText color="secondary-900">Contact your Kula admin for help</KText>
        </Flex>
      </Flex>
      <Box position="absolute" bottom="0" mb="24px">
        <TradeMarkFooter
          isSignUp={false}
          trademarkFooterStyles={{
            height: '48px',
          }}
        />
      </Box>
    </Flex>
  );
};

export default SSOFailurePage;
